import { render } from "./viewform.vue?vue&type=template&id=c36b85ec&scoped=true"
import script from "./viewform.js?vue&type=script&lang=js"
export * from "./viewform.js?vue&type=script&lang=js"

import "./viewform.vue?vue&type=style&index=0&id=c36b85ec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36b85ec"]])

export default __exports__